import * as Utils from '@ext/index';
export { };

export class Estados
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Estados
    {

        if ( id === this.Activo.Id )
            return this.Activo;
        else if ( id === this.Pausado.Id )
            return this.Pausado;
        else if ( id === this.Finalizado.Id )
            return this.Finalizado;
        else if ( id === this.Creado.Id )
            return this.Creado;


        return new Estados( id, id );
    }

    public static readonly Creado: Estados = new Estados( 'creado', 'Creado' );
    public static readonly Activo: Estados = new Estados( 'activo', 'Activo' );
    public static readonly Pausado: Estados = new Estados( 'pausado', 'Pausado' );
    public static readonly Finalizado: Estados = new Estados( 'finalizado', 'Finalizado' );

    public static Options: Array<Estados> = [
        Estados.Activo,
        Estados.Pausado,
        Estados.Finalizado,
        Estados.Creado,
    ];

    public get esActivo(): boolean { return this.Id === Estados.Activo.Id; }
    public get esPausado(): boolean { return this.Id === Estados.Pausado.Id; }
    public get esFinalizado(): boolean { return this.Id === Estados.Finalizado.Id; }
    public get esCreado(): boolean { return this.Id === Estados.Creado.Id; }

    public static get Filter(): { Nombre: string; Id: string, Valor: Estados[]; }[]
    {
        let tt: { Nombre: string; Id: string, Valor: Estados[]; }[] = [];
        tt.push( { Nombre: 'Todos', Id: 'todos', Valor: [] } );
        for ( let t of Estados.Options )
        {
            tt.push( { Nombre: t.Descripcion, Id: t.Id, Valor: [t] } );
        }
        return tt;
    }
}


export class Tipos
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Tipos
    {

        if ( id === this.Ventas.Id )
            return this.Ventas;
        else if ( id === this.Otros.Id )
            return this.Otros;


        return new Tipos( id, id );
    }

    public static readonly Ventas: Tipos = new Tipos( 'ventas', 'Ventas' );
    public static readonly Otros: Tipos = new Tipos( 'otro', 'Otros' );

    public static Options: Array<Tipos> = [
        Tipos.Ventas,
        Tipos.Otros,

    ];

    public get esVentas(): boolean { return this.Id === Tipos.Ventas.Id; }
    public get esOtros(): boolean { return this.Id === Tipos.Otros.Id; }

    public static get Filter(): { Nombre: string; Id: string, Valor: Tipos[]; }[]
    {
        let tt: { Nombre: string; Id: string, Valor: Tipos[]; }[] = [];
        tt.push( { Nombre: 'Todos', Id: 'todos', Valor: [] } );
        for ( let t of Tipos.Options )
        {
            tt.push( { Nombre: t.Descripcion, Id: t.Id, Valor: [t] } );
        }
        return tt;
    }
}
